import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";

const backgroundImage = require("../../assets/images/Background.png");
const logoImage = require("../../assets/images/PIH_logo_white.png");

const Auth = () => {
  const location = useLocation();
  const isPageLogin = location.pathname === "/auth/login" ? true : false;
  return (
    <AuthOutletContainer>
      {!isPageLogin && (
        <LoginIconBar>
          <img src={logoImage} alt="PIH" />
        </LoginIconBar>
      )}
      <Outlet />
    </AuthOutletContainer>
  );
};

export default Auth;

const AuthOutletContainer = styled.div`
  background: url(${backgroundImage}) no-repeat center;
  background-size: cover;
  width: 100%;
  height: 100vh;
`;
const LoginIconBar = styled.div`
  position: absolute;
  transform: translate(2.5rem, 2rem);
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;
